export default "__VITE_ASSET__f0fdcd09__"